module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point02_01_winter-24a37db158589976704aa8de49c004fc.jpg";